import { render } from "./ModerationLogs.vue?vue&type=template&id=3940a478&scoped=true"
import script from "./ModerationLogs.vue?vue&type=script&lang=js"
export * from "./ModerationLogs.vue?vue&type=script&lang=js"

import "./ModerationLogs.vue?vue&type=style&index=0&id=3940a478&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3940a478"]])

export default __exports__